import { Skeleton, Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';
import { useTheme } from '~/themes';
import { TextSx, VariationSize } from './types';

interface TextProps extends TypographyProps<'div'> {
  isLoading?: boolean;
  variant?: 'body1' | 'body2';
  color?: string;
  fontSize?: string | number | VariationSize;
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  sx?: TextSx;
  skeletonSx?: Pick<TypographyProps<'div'>, 'fontSize' | 'marginY' | 'width'>;
  useCognitoMode?: boolean;
}

const Text: FC<TextProps> = ({
  isLoading = false,
  color,
  children,
  variant = 'body1',
  fontSize,
  align = 'left',
  sx,
  skeletonSx,
  useCognitoMode = false,
}) => {
  const { COLORS } = useTheme();
  const { marginBottom, marginY, alignItems = 'center', fontWeight = 'normal', ...othersSx } = sx ?? {};
  const { fontSize: skeletonFontSize, marginY: skeletonMarginY = 1 / 2, width = '80%' } = skeletonSx ?? {};

  color = color || COLORS.text.primary;

  return isLoading ? (
    <Skeleton variant='text' sx={{ width, fontSize: skeletonFontSize, marginY: skeletonMarginY }} />
  ) : (
    <Typography
      component={'div'}
      variant={variant}
      sx={{
        color,
        marginBottom,
        marginY,
        alignItems,
        fontWeight,
        fontSize,
        ...othersSx,
        ...(useCognitoMode === true && {
          color: 'transparent',
          textShadow: '0 0 7px rgba(0,0,0,0.7)',
        }),
      }}
      align={align}
    >
      {children}
    </Typography>
  );
};

export { Text };
